(function() {
	'use strict';

	angular.module('widgets.initiative')
	.service('leanProjectTaskSummaryService', leanProjectTaskSummaryService);

	function leanProjectTaskSummaryService($http, hostUrl) {
		var baseUrl = hostUrl + '2/factndx/';
		return {
			getLeanProjectTaskSummary: getLeanProjectTaskSummary
		};

		function getLeanProjectTaskSummary(filterService) {
			var url = baseUrl;
			url += filterService.getFactoryList();
			url += '/LeanProjectTaskSummary';
			url = addQueryParam(url, filterService.getFactoryList(), filterService.getQueryParamsObject(true),false);

			return $http.get(url)
				.then(getProjectsTargetVsActualComplete)
				.catch(getProjectsTargetVsActualFailed);

			function getProjectsTargetVsActualComplete(response) {
				return response.data;
			}
			function getProjectsTargetVsActualFailed(error) {
				return error;
			}
		}
	}
})();